import { create } from 'zustand';

interface DebugState {
  /** 발급된 FCM 토큰 (native bridge / web FCM SDK 공용). 미발급/거부 시 null. */
  fcmToken: string | null;
  setFcmToken: (token: string) => void;
}

/**
 * 디버그 다이얼로그(설정 헤더 타이틀 5연타로 진입) 노출용 런타임 값 캡처 store.
 *
 * fcmToken 은 push 코디네이터(`fcm-sync`) 로만 흐르고 UI 로 새지 않으므로, composition 이
 * 토큰 공급 콜백에서 이 store 에도 미러링해 다이얼로그가 구독할 수 있게 한다. 빌드 게이팅은 없다
 * (운영 포함) — 진입이 히든 제스처뿐이고 값도 사용자 본인 디바이스 정보. 관련 ADR: push-notifications.
 */
export const useDebugStore = create<DebugState>((set) => ({
  fcmToken: null,
  setFcmToken: (fcmToken) => set({ fcmToken }),
}));
